import React, { useState, useEffect } from "react";
import { Modal, Button, Carousel } from "react-bootstrap";
import firstImage from "../assets/carousels/firstImage.png";
import Any_questions from "../assets/carousels/Any_questions.png";
import clocksTrend from "../assets/carousels/new/clocksTrend.png";
import customPlap from "../assets/carousels/new/customPlap.png";
import clocksRatings from "../assets/carousels/new/clocksRatings.png";
import tslModule from "../assets/carousels/new/tslModule.png";
import twoFactors from "../assets/carousels/new/twoFactors.png";
import hybridHitlist from "../assets/carousels/new/hybridHitlist.png";
import healthPopup from "../assets/carousels/new/healthPopup.png";

export default function CarouselModal() {
    const marketingData = [
        {
            title: "NEW FEATURES APRIL 2026",
            description: (
                <>
                    Let us take you on a tour! Just click through this slideshow. If you have any questions reach out at{" "}
                    <a className="text-dark fw-bold " href="mailto:support@radioanalyzer.com" target="_blank" rel="noreferrer">
                        support@radioanalyzer.com
                    </a>
                </>
            ),

            image: firstImage,
        },
        {
            title: "Trend Over Time from Clocks",
            description: "Get trend data for Song Scores instantly with one click directly from your clocks view, no need to switch over to music testing.",
            image: clocksTrend,
        },
        {
            title: "Custom Plap in Settings",
            description:
                "Customize your Playlist Autopilot to Import and Export directly to and from your Music Planning Software. Playlist meeting prep and execution can now be completed entirely within RadioAnalyzer.",
            image: customPlap,
        },
        {
            title: "Clocks from Ratings",
            description: "If hourly grouping is selected you can simply click on a data point and Clocks will show up.",
            image: clocksRatings,
        },
        {
            title: "TSL module",
            description:
                "Compare your TSL to recent averages, or against your performance in the past year – especially useful for seasonal events or changes during ratings periods.",
            image: tslModule,
        },
        {
            title: "2Factor Authentication",
            description: "You can now enable 2-Factor Authentication under Settings for an extra layer of security and peace of mind.",
            image: twoFactors,
        },
        {
            title: "Hybrid Hitlist - pop-up ranking",
            description: 'Click on "TREND" to see a pop-up with a clear trend view of how the song’s position has evolved over time.',
            image: hybridHitlist,
        },
        {
            title: "Health - Trend pop-up",
            description:
                "With the new Health Trend pop-up, you can track how your radio performs over time — from ratings and sessions to listener groups and TSL.",
            image: healthPopup,
        },
        {
            title: "ANY QUESTIONS?",
            description: (
                <>
                    Need help navigating or have a technical question? We are happy to hear from you at{" "}
                    <a className="text-dark fw-bold " href="mailto:support@radioanalyzer.com" target="_blank" rel="noreferrer">
                        support@radioanalyzer.com
                    </a>
                </>
            ),
            image: Any_questions,
        },
    ];

    const [show, setShow] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleSelect = selectedIndex => {
        setCurrentIndex(selectedIndex);
    };
    useEffect(() => {
        const hideForever = localStorage.getItem("hideNewestCarouselModal");
        if (!hideForever) {
            setShow(true);
        }
    }, []);

    const handleCloseOnlyThisTime = () => {
        setShow(false);
    };

    const handleCloseForever = () => {
        localStorage.setItem("hideNewestCarouselModal", "true");
        setShow(false);
    };

    return (
        <>
            <Modal show={show} onHide={handleCloseOnlyThisTime} size="xl" centered>
                <Modal.Body className="modal-carousel-body">
                    <Carousel variant="dark" interval={null} controls indicators activeIndex={currentIndex} onSelect={handleSelect}>
                        {marketingData.map((item, index) => (
                            <Carousel.Item key={index}>
                                {item.image && <img src={item.image} alt={item.title} style={{ maxHeight: "60vh", width: "100%", objectFit: "cover" }} />}
                            </Carousel.Item>
                        ))}
                    </Carousel>
                    {/* Text below the carousel */}
                    {marketingData.length > 0 && (
                        <div className="text-center modal-text-container mt-3">
                            <h3 className="text-uppercase">{marketingData[currentIndex].title}</h3>
                            <span>{marketingData[currentIndex].description}</span>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="">
                    <Button variant="secondary" onClick={handleCloseOnlyThisTime}>
                        Close only this time
                    </Button>
                    <Button variant="danger" onClick={handleCloseForever}>
                        Close forever
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
